import React from 'react';

export const FormSubmitError = (props) => {
  return (
    (props.message) ? 
      <div className={'alert alert-danger'}>{props.message}</div>    
    : ''

  );
};

export const FormValidationError = (props) => {
  
  let errorsArray = props.errors;

  let errorsDivs = errorsArray.map((error, index) => {
    return <div key={index} className={'alert alert-danger'}>{error}</div>;
  });
  
  return (
    <div>{errorsDivs}</div>
  );
};

 